import * as MapRegions from './googleMapRegions';
import * as ExtendedRegions from './giftDeliveryRegions';

export const DEFAULT_LOCATION = {
  lat: -34.397,
  lng: 150.644
}
export const DEFAULT_MAP_ZOOM = 14;
var geocoder,
  bikeDeliveryPolygon,
  dontDeliverHerePolygon,
  carDeliveryPolygon,
  silverlakeDeliveryArea,
  extendedDeliveryArea;

export function initMap(element, options, onPlaceChanged) {

  let map = new google.maps.Map(element, {
    center: options && options.center
      ? options.center
      : DEFAULT_LOCATION,
    zoom: options && options.zoom
      ? options.zoom
      : DEFAULT_MAP_ZOOM
  });

  //Car drivers can deliver within these location
  carDeliveryPolygon = new google.maps.Polygon({
    paths: MapRegions.REGION_CAR_DELIVERY,
    strokeColor: '#7C3592',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#7c3592',
    fillOpacity: 0
  });
  carDeliveryPolygon.setMap(map);

  //Bike drivers can delivery within these locations
  bikeDeliveryPolygon = new google.maps.Polygon({
    paths: MapRegions.REGION_BIKE_DELIVERY,
    strokeColor: '#62af44',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#ffffff',
    fillOpacity: 0
  });
  bikeDeliveryPolygon.setMap(map);

  //Jasons dont deliver within these locations
  dontDeliverHerePolygon = new google.maps.Polygon({
    paths: [
      MapRegions.REGION_NO_DELIVERY1, MapRegions.REGION_NO_DELIVERY2
    ],
    strokeColor: '#db3636',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#db3636',
    fillOpacity: 1
  });
  dontDeliverHerePolygon.setMap(map);

  silverlakeDeliveryArea = new google.maps.Polygon({
    paths: [
      MapRegions.SILVERLAKE_BIKE_DELIVERY,
      MapRegions.SILVERLAKE_CAR_DELIVERY
    ],
    strokeColor: '#db3636',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#db3636',
    fillOpacity: 0
  })
  silverlakeDeliveryArea.setMap(map);

  extendedDeliveryArea = new google.maps.Polygon({
    paths: [
      ExtendedRegions.GIFT_SAME_DAY_DELIVERY,
      ExtendedRegions.GIFT_DAYS_NOTICE_DELIVERY_1,
      ExtendedRegions.GIFT_DAYS_NOTICE_DELIVERY_2,
    ],
    strokeColor: '#db3636',
    strokeOpacity: 0.1,
    strokeWeight: 0,
    fillColor: '#db3636',
    fillOpacity: 0
  });
  extendedDeliveryArea.setMap(map);

  _addPolygonClickEvent(dontDeliverHerePolygon, onPlaceChanged);
  _addPolygonClickEvent(carDeliveryPolygon, onPlaceChanged);
  _addPolygonClickEvent(bikeDeliveryPolygon, onPlaceChanged);
  _addPolygonClickEvent(silverlakeDeliveryArea, onPlaceChanged);
  _addPolygonClickEvent(extendedDeliveryArea, onPlaceChanged);

  return map;
}

export function addMarker(map, location, title = 'Your location') {
  map.setCenter(new google.maps.LatLng(location.lat, location.lng));
  return new google.maps.Marker({position: location, map: map, title: title, draggable: true});
}

export function updateMarker(map, marker, location) {
  map.setCenter(new google.maps.LatLng(location.lat, location.lng));
  if (marker && location)
    marker.setPosition(location);
  }

export function getLocationByPlace(place) {
  if (place && place.geometry) {

    let latitude = (typeof place.geometry.location.lat === 'number')
      ? place.geometry.location.lat
      : place.geometry.location.lat();
    let logitude = (typeof place.geometry.location.lng === 'number')
      ? place.geometry.location.lng
      : place.geometry.location.lng();
    return {lat: latitude, lng: logitude}
  } else
    return null;
  }

export function addMarkerDragEvent(marker, onPlaceChanged) {

  google.maps.event.addListener(marker, 'dragend', (event) => _locationEventHandler(event, onPlaceChanged));
}

export function addMapClickEvent(map, onPlaceChanged) {
  google.maps.event.addListener(map, 'click', (event) => _locationEventHandler(event, onPlaceChanged));
}

export function getPlaceByLatLng(lat, lng) {
  let latLng = new google.maps.LatLng(lat, lng);
  return new Promise((resolve, reject) => {
    _reverseGeocode({'location': latLng}).then(place => {
      if (place && place.geometry.location) {
        resolve(place);
      }
    }).catch(error => reject(error));
  });
}

function _addPolygonClickEvent(map, onPlaceChanged) {
  google.maps.event.addListener(map, 'click', (event) => _locationEventHandler(event, onPlaceChanged));
}

function _locationEventHandler(event, onPlaceChanged) {
  _reverseGeocode({'location': event.latLng}).then(place => {
    if (place && place.geometry.location) {
      onPlaceChanged(place);
    }
  }).catch(error => console.error('Reverse geocode error: ', error));
}

export function setAutocompleteService(inputElement, eventHandler) {
  var autocomplete = new google.maps.places.Autocomplete(inputElement);
  autocomplete.addListener('place_changed', () => {
    var place = autocomplete.getPlace();
    if (place.geometry) {
      eventHandler(place);
    }
  })
}

function _reverseGeocode(geocodeOptions) {

  return new Promise((resolve, reject) => {
    _getGeocoder().geocode(geocodeOptions, (results, status) => {
      if (status === 'OK') {
        if (results[0])
          resolve(results[0]);
        else
          reject('No results found');
        }
      else {
        reject('Geocoder failed due to: ' + status);
      }
    });
  })
}

function _getGeocoder() {
  if (!geocoder)
    geocoder = new google.maps.Geocoder;
  return geocoder;
}

export function checkAreaDeliverable(data) {

  console.log(data);
  var ifMarkerInRestrictedArea = google.maps.geometry.poly.containsLocation(data, dontDeliverHerePolygon);
  var ifMarkerInDeliverByCarArea = google.maps.geometry.poly.containsLocation(data, carDeliveryPolygon);
  var ifMarkerInDeliverByBikeArea = google.maps.geometry.poly.containsLocation(data, bikeDeliveryPolygon);
  var ifMarkerInSilverlakeArea = google.maps.geometry.poly.containsLocation(data, silverlakeDeliveryArea);
  var ifMarkerInExtendedArea = google.maps.geometry.poly.containsLocation(data, extendedDeliveryArea);

  return _handleLocationValidation(
    ifMarkerInRestrictedArea,
    ifMarkerInDeliverByCarArea, ifMarkerInDeliverByBikeArea,
    ifMarkerInSilverlakeArea, ifMarkerInExtendedArea
  );
}

function _handleLocationValidation(restrictedArea, carArea, bikeArea, ifMarkerInSilverlakeArea, ifMarkerInExtendedArea) {
  // eslint-disable-next-line no-console
  console.debug('_handleLocationValidation', carArea, bikeArea, ifMarkerInSilverlakeArea, ifMarkerInExtendedArea);

  let area = ifMarkerInSilverlakeArea ? 'silverlake': 'downtown';

  if (restrictedArea) {
    return 'restricted';
  }

  if (
    bikeArea
    || carArea
    || ifMarkerInSilverlakeArea
    || ifMarkerInExtendedArea
  ) {
      return area;
  } else {
    return 'outside';
  }
}

/**
 * Get the value for a given key in address_components
 *
 * @param {Array} components address_components returned from Google maps autocomplete
 * @param type key for desired address component
 * @returns {String} value, if found, for given type (key)
 */
export function extractFromAddress(components, type, keyType) {
  return (
    components
      .filter(component => component.types.indexOf(type) === 0)
      .map(item => item[keyType] || item.name || item.long_name || item.short_name) // Preference to long_name over short_name unless specified by keyType - for example in case of country or state.
      .pop() || null
  );
}



// WEBPACK FOOTER //
// ./src/utils/googleApiHelper.js